import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './container/Home';
import AboutUs from './container/Pages/AboutUs';
import OurStory from './container/Pages/OurStory';
import MissionVision from './container/Pages/MissionandVision';
import Retail from './container/Pages/Retail';
import Healthcare from './container/Pages/Healthcare';
import Agriculture from './container/Pages/Agriculture';
import Education from './container/Pages/Education';
import Manufacturing from './container/Pages/Manufecturing';
import Logistics from './container/Pages/Logistics';
import Grocery from './container/Pages/Grocery';
import Fashion from './container/Pages/Fashion';
import Contact from './container/Pages/Contact';
import GetQuote from './container/Pages/GetQuote';




function App() {
  return (
    <div className="App">
      <Router>


        <Routes>
          <Route exact path='/' element={<Home />} />
          <Route path='/about' element={<AboutUs/>}/>
          <Route path='/our-story' element={<OurStory/>}/>
          <Route path='/mission-vision' element={<MissionVision/>}/>
          <Route path='/retail' element={<Retail/>}/>
          <Route path='/healthcare' element={<Healthcare/>}/>
          <Route path='/agriculture' element={<Agriculture/>}/>
          <Route path='/education' element={<Education/>}/>
          <Route path='/manufecturing' element={<Manufacturing/>}/>
          <Route path='/logistics' element={<Logistics/>}/>
          <Route path='/grocery' element={<Grocery/>}/>
          <Route path='/fashion' element={<Fashion/>}/>
          <Route path='/contact' element={<Contact/>}/>
          <Route path='/get-quote' element={<GetQuote/>}/>



          
        </Routes>
      </Router>
    </div>
  );
}

export default App;
